import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Modal } from 'components/Modal/Modal'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { attendanceTypesOptions } from './data'
import { ISelectValue } from 'constants/globalTypes'
import { HonestTimePickerInput } from 'components/HonestTimePicker/HonestTimePickerInput'
import { createAttendance, createMultipleAttendance } from 'features/attendance/attendanceSlice'
import { minutesToUTCDate } from 'utils/helpers'

export const AttendanceModal = ({
    closeModal,
    value,
}: {
    closeModal: any
    value?: IAttendanceModal
}) => {
    const [state, setState] = useState<IAttendanceModal>(
        value || {
            userId: null,
            attendanceType: { value: null, label: '' },
            checkIn: null,
            checkOut: null,
            offset: 0,
            offsetType: null,
            shiftId: null,
            date: null,
            workScheduleIds: [],
            userIds: [],
            userName: null,
            shiftName: null
        },
    )
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {

        const resp = state?.userIds?.length ? await dispatch(createMultipleAttendance({
            userIds: state.userIds,
            workScheduleIds: state.workScheduleIds || [],
            startDate: minutesToUTCDate(state.checkIn, state.date).toISOString(),
            endDate: state?.checkOut
                ? minutesToUTCDate(state?.checkOut, state.date).toISOString()
                : null,
            type: state.attendanceType.value
        })) : await dispatch(createAttendance(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const handleSelect = (v: ISelectValue) => {
        setState((prev) => ({ ...prev, attendanceType: v }))
    }

    const handleTimeChange = (time: string, name: string) => {
        const splitted = time.split(':')
        const minutes = parseInt(splitted[0]) * 60 + parseInt(splitted[1])
        setState((prev) => {
            const copy = { ...prev }
            if (name == 'checkIn') {
                return { ...copy, checkIn: minutes }
            } else {
                return { ...copy, checkOut: minutes }
            }
        })
    }

    return (
        <Modal black>
            <Flex column between center >
                <Flex column gap='1rem' width='100%' style={{ marginBottom: '1rem' }}>
                    <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                        <TitleText weight='bold'>{value?.id ? 'Edit' : 'Add'} Attendance</TitleText>
                        <CursorPointer onClick={closeModal}>
                            <CloseIcon />
                        </CursorPointer>
                    </Flex>
                    {state.userName && <Flex column >
                        <BodyText weight='bold' >{state.userName}</BodyText>
                        {state?.shiftName && <OtherText>Scheduled: {state.shiftName}</OtherText>}
                    </Flex>}
                    <HonestSelectInput
                        options={attendanceTypesOptions}
                        defaultValue={state.attendanceType?.value}
                        onChange={handleSelect}
                        labelText='Attendance'
                        name='attendanceType'
                        nomarg
                    />
                    {[1, 4, 8, 11].includes(state?.attendanceType?.value) && (
                        <Flex column gap='1rem' >
                            <Flex gap='2rem'>
                                <HonestTimePickerInput
                                    onChange={(v) => handleTimeChange(v, 'checkIn')}
                                    labelText='Check in'
                                    defaultValue={state.checkIn}
                                    nomarg
                                />
                                <HonestTimePickerInput
                                    onChange={(v) => handleTimeChange(v, 'checkOut')}
                                    labelText='Check out'
                                    defaultValue={state.checkOut}
                                    nomarg
                                />
                            </Flex>
                            {/* <Input width='200px' labelText='Time difference' name='diff' onChange={() => null} disabled value={formatMinutesToTime(state.checkOut - state.checkIn)} /> TODO */}
                        </Flex>

                    )}
                </Flex  >
                <Button disabled={!state?.attendanceType?.value} orange onClick={handleSave}>
                    Save
                </Button>
            </Flex>
        </Modal>
    )
}

export interface IAttendanceModal {
    id?: number
    userId: number
    attendanceType: ISelectValue
    checkIn: number
    checkOut: number
    offset: number
    offsetType: number
    shiftId?: number
    date: Date
    workScheduleIds?: number[]
    userIds: number[]
    userName?: string
    shiftName?: string
}
